<template>
  <div>
    <DPlayer :url=$route.query.src></DPlayer>
  </div>
</template>

<script>
export default {

}
</script>

<style lang='less' scoped>

</style>